import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState } from 'react';

const getDeviceIdFromStorage = () => {
  if (typeof(localStorage) === 'object') {
    let deviceId = localStorage?.getItem('deviceId') ?? '';
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  } else {
    return '';
  }
}

const useDeviceId = () => {
  const [deciveId, setDeviceId] = useState<string>(() => {
    return getDeviceIdFromStorage();
  });

  useEffect(() => {
    let deviceId = getDeviceIdFromStorage();
    setDeviceId(() => deviceId);
  }, []);

  return [deciveId];
};

export default useDeviceId;
